import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import common from '@/store/common';
import auth from '@/store/auth';

export default new Vuex.Store({
  modules: {
    common,
    auth,
  },
  plugins: [createPersistedState({
    getState: (key, storage) => {
      try {
        const saved = JSON.parse(storage.getItem(key) || 'null');
        if (!saved || typeof saved !== 'object') return undefined;
        // Keep preferences only; remove legacy tokens and cached identity before rehydration.
        const preferences = {
          auth: { mailConfirmation: saved.auth?.mailConfirmation || { email: undefined, new: false } },
          common: { cookiesAccepted: saved.common?.cookiesAccepted, locale: saved.common?.locale },
        };
        storage.setItem(key, JSON.stringify(preferences));
        return preferences;
      } catch {
        return undefined;
      }
    },
    reducer: (state) => ({
      auth: {
        mailConfirmation: state.auth.mailConfirmation,
      },
      common: {
        cookiesAccepted: state.common.cookiesAccepted,
        locale: state.common.locale,
      },
    }),
  })],
  strict: true,
});
